import store from '@/store'
import roles from '@/const/roles'
export const canViewMenuItem = item => {
   //return true;
   if(store.state.auth.userData === undefined){return false}
   const permissions = store.state.auth.userData?.permissions ?? []
  
   if (store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)) return true
   return permissions.includes(item.name) || store.state.auth.allUsersPages.includes(item.name)
}
